// @flow

import * as React from 'react';
import Group from 'sail/Group';
import Icon from 'sail/Icon';
import {Interactive} from 'sail/Interactive';
import {Text} from 'sail/Text';
import TruncatedText from 'sail/TruncatedText';
import {UnstyledLink} from 'sail/UnstyledLink';

type XRaySidebarLinkProps = {|
  href: string,
  icon?: string,
  label: React.Node,
|};

export const XRaySidebarLink = ({href, icon, label}: XRaySidebarLinkProps) => (
  <Interactive>
    {({mouse}) => (
      <Group direction="horizontal" spacing={4}>
        {/* $FlowExpectedError icon wants a specific string but we just have a generic one */}
        {icon && <Icon icon={icon} color="default" size={14} />}
        <Text
          size={12}
          typeface="mono"
          color={mouse === 'hover' ? 'default' : 'blue'}
        >
          <TruncatedText>
            <UnstyledLink href={href} target="_external">
              {label}
            </UnstyledLink>
          </TruncatedText>
        </Text>
      </Group>
    )}
  </Interactive>
);
